<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close(false)" *ngIf="!data.confirmOnly">
    {{ 'userdialog.cancel' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="dialogRef.close(true)">
    {{ 'userdialog.confirm' | translate }}
  </button>
</mat-dialog-actions>
